import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

/** Auth guard — redirects to /login when the user is not authenticated. */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const isAuthenticated = useAuthStore(s => s.isAuthenticated)
    if (!isAuthenticated) return <Navigate to="/login" replace />
    return <>{children}</>
}
